import { PayStatement } from "@wingspanhq/wingspan-api-sdk";

/**
 * The work logs a statement paid. The v3 pay statement carries no
 * `sourceWorkLogIds`; each earning line references the work log it paid, so the
 * source set is the earnings' ids.
 */
export const selectorPayStatementWorkLogIds = (
  payStatement: PayStatement
): string[] =>
  (payStatement.earnings ?? [])
    .map(earning => earning.workLogId)
    .filter((id): id is string => !!id);
